import React, { useState, useEffect } from 'react';
import { TextField, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  createTraining,
  deleteTraining,
  updateTraining,
} from '../../actions/trainings.js';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import { getAllFlashcardHeaders, getFlashcards } from '../../actions/flashcards';
import { getTrainings } from '../../actions/trainings';
// import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import FileBase from 'react-file-base64';

import {
  convertToBase64,
  createMarker,
} from '../common/imageUtils';
// import MenuItem from '@material-ui/core/MenuItem';
// import Select from '@material-ui/core/Select';
// solve state issue?
// https://www.newline.co/@brookslybrand/common-mistake-with-synchronizing-state-in-react--8ab767b5
const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    padding: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  fileInput: {
    width: '97%',
    margin: '10px 0',
  },
  buttonSubmit: {
    margin: 10,
  },
  buttonClear: {
    margin: 10,
  },

  root: {
    margin: 'auto',
  },
  cardHeader: {
    padding: theme.spacing(1, 2),
  },
  list: {
    width: 200,
    height: 230,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
}));

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

const Trainingform = ({ training, currentId, close }) => {
  const flashcardHeaders = useSelector((state) => state.flashcardHeaders);

  const classes = useStyles();
  const dispatch = useDispatch();
  const [trainingData, settrainingData] = useState({
    name: '',
    owner: '',
    flashcardIds: [],
    lastupdated: '',
    active: true,
    logo: '',
  });

  useEffect(() => {
    dispatch(getAllFlashcardHeaders());
    dispatch(getTrainings());
  }, [currentId, dispatch]);

  // console.log(flashcardHeaders);

  //   const height = 200;
  // console.log('trainingData id', trainingData._id);

  const processClick = (evt) => {
    var element = document.getElementById('logomarker');
    if (element !== null) {
      element.parentNode.removeChild(element);
    }

    settrainingData({
      ...trainingData,
      logo: '',
    });
  };

  useEffect(() => {
    if (training) {
      settrainingData(training);
    }
    var element = document.getElementById(`logomarker`);
    if (element !== null) {
      element.parentNode.removeChild(element);
    }
    const logo = document.getElementById(`trainingslogo`);

    if (logo !== null) {
      const newLeft =
        logo.getBoundingClientRect().x -
        logo.parentNode.getBoundingClientRect().x +
        logo.getBoundingClientRect().width -
        30;

      const newTop =
        170 +
        logo.getBoundingClientRect().y -
        logo.parentNode.getBoundingClientRect().y;
      let marker = createMarker('minusicon.svg');
      marker.setAttribute('id', `logomarker`);
      const logoarea = document.getElementById('trainimgareaid');
      logoarea.appendChild(marker);
      marker.setAttribute(
        'style',
        `left: ${newLeft}px; z-index: 300000; top: ${newTop}px; position:absolute;
      background-color: transparent; border: 0px solid transparent;
      box-shadow: 0 0 0 rgba(0, 0, 0, 0);
      padding: 0;
      margin: 0;
      outline: none;
      `,
      );
      marker.addEventListener('click', (event) => processClick(event));
    }

    // const image = document.getElementById(`image_${i}`);
  }, [training]);

  // console.log(training);
  // console.log(trainingData);

  const clear = () => {
    settrainingData({
      name: '',
      owner: '',
      flashcardIds: [],
      lastupdated: '',
      active: true,
      logo: '',
    });
  };

  // const updateIds = () => {
  //   let ids = right.map((item) => {
  //     return item._id;
  //   });
  //   console.log(ids);
  //   settrainingData({
  //     ...trainingData,
  //     flashcardIds: ids,
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentId === 0) {
      dispatch(createTraining(trainingData));
      // clear();
    } else {
      await dispatch(updateTraining(trainingData._id, trainingData));
      dispatch(getAllFlashcardHeaders());
      dispatch(getFlashcards());
      // clear();
    }
    close();
  };

  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState(
    training == undefined
      ? flashcardHeaders
      : flashcardHeaders.filter(
          (flashcard) => !training.flashcardIds.includes(flashcard._id),
        ),
  );

  // const [left, setLeft] = React.useState(flashcardHeaders);
  const [right, setRight] = React.useState(
    training == undefined
      ? []
      : flashcardHeaders.filter((flashcard) =>
          training.flashcardIds.includes(flashcard._id),
        ),
  );

  useEffect(() => {
    let ids = right.map((item) => {
      return item._id;
    });
    settrainingData({
      ...trainingData,
      flashcardIds: ids,
    });
  }, [left, right]);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    // updateIds();
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
    // updateIds();
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
    // updateIds();
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
    // updateIds();
  };

  const customList = (title, items) => (
    <Card>
      <CardHeader
        className={classes.cardHeader}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{ 'aria-label': 'all items selected' }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List className={classes.list} dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;
          // console.log(value._id);
          return (
            <ListItem
              key={value._id}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ 'aria-labelledby': labelId }}
                />
              </ListItemIcon>

              <ListItemText id={labelId} primary={`${value.header.title}`} />
            </ListItem>
          );
        })}
        <ListItem />
      </List>
    </Card>
  );

  const pasting = async (e) => {
    if (
      e.clipboardData.files === null ||
      e.clipboardData.files[0] === undefined
    ) {
      console.log('no file in clipboard');
    } else {
      const base64 = await convertToBase64(e.clipboardData.files[0]);

      settrainingData({
        ...trainingData,
        logo: base64,
      });
    }
  };

  return (
    <div>
      <Dialog open>
        <DialogTitle id="simple-dialog-title">
          {currentId == 0 ? 'Create' : 'Update'} training:
        </DialogTitle>
        {/* https://codesandbox.io/s/xr292j5oq4?file=/src/index.js:312-379 */}
        {/* <Grid
          container
          direction="row"
          // spacing="2"
          style={{ margin: 0 }}
        >
          <Grid item></Grid>
          <Grid item>
          </Grid>
        </Grid> */}
        Name
        <TextField
          value={trainingData.name}
          onChange={(e) => {
            let ids = right.map((item) => {
              return item._id;
            });
            settrainingData({
              ...trainingData,
              name: e.target.value,
              flashcardIds: ids,
            });
          }}
        />
        {/* Filter Flashcards
        <TextField
          value={trainingData.flashcardIds}
          onChange={(e) =>
            settrainingData({
              ...trainingData,
              flashcardIds: e.target.value.split(','),
            })
          }
        /> */}
        <Grid item>
          <Switch
            checked={trainingData.active}
            onChange={(e) => {
              settrainingData({
                ...trainingData,
                active: e.target.checked,
              });
            }}
          />
          active
        </Grid>
        {/* <Grid
          container
          spacing={2}
          justify="center"
          alignItems="center"
          className={classes.root}
        >
          <Grid item>{customList('Available Flashcards', left)}</Grid>
          <Grid item>
            <Grid container direction="column" alignItems="center">
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
              >
                &gt;
              </Button>
              <Button
                variant="outlined"
                size="small"
                className={classes.button}
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
              >
                &lt;
              </Button>
            </Grid>
          </Grid>
          <Grid item>{customList('Chosen Flashcards', right)}</Grid>
        </Grid> */}
        <div
          onPaste={pasting}
          style={{
            height: `300px`,
            border: '2px solid rgba(0, 0, 0, 1.0)',
          }}
        >
          <div onPaste={pasting} id="trainimgareaid">
            {trainingData.logo !== undefined && trainingData.logo !== '' ? (
              <img
                id={`trainingslogo`}
                src={trainingData.logo}
                height="300"
                onPaste={pasting}
                style={{ border: '0px solid rgba(0, 0, 0, 1.0)' }}
              />
            ) : (
              <img height="300" onPaste={pasting} />
            )}
          </div>
        </div>
        <FileBase
          type="file"
          multiple={false}
          onDone={({ base64 }) =>
            settrainingData({
              ...trainingData,
              logo: base64,
            })
          }
        />
        <Button
          className={classes.buttonSubmit}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          fullWidth
          onClick={(e) => {
            settrainingData({
              ...trainingData,
              created: new Date().toISOString(),
            });
            handleSubmit(e);
          }}
        >
          {currentId == 0 ? 'Submit' : 'Update'}
        </Button>
        <Button
          onClick={clear}
          className={classes.buttonClear}
          variant="contained"
          color="secondary"
          size="small"
          fullWidth
        >
          Clear
        </Button>
        {currentId == 0 ? (
          []
        ) : (
          <Button
            onClick={() => {
              dispatch(deleteTraining(trainingData._id));
              close();
            }}
            className={classes.buttonClear}
            variant="contained"
            color="secondary"
            size="small"
            fullWidth
          >
            Delete
          </Button>
        )}
        <Button
          onClick={close}
          className={classes.buttonClear}
          variant="contained"
          color="secondary"
          size="small"
          fullWidth
        >
          Close
        </Button>
      </Dialog>
    </div>
  );
};

export default Trainingform;
